<section fxLayout="row" fxFlexAlign="stretch" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column"
    fxLayoutAlign="center center">
    <div fxFlex="100%" fxFlex.gt-md="30%" fxLayout="column" fxFlexAlign="center">
        <br />
        <div fxLayout="row" fxFlexAlign="center">
            <img id="welcomeLogo" fxFlex="0 100 100%" class="img-fluid" [src]="'assets/image/splash.png'"
                alt="WEST Logo" />
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center" class="layout-wrapper" fxFlex="40%" fxFlex.gt-md="30%">
        <div fxFlex="60%" fxFlex.sm="50%" fxFlex.md="50%" fxFlex.xs="80%" fxLayout="column" fxLayoutGap="5%" class="flex-wrapper">
            <div fxLayout="column" fxFlexAlign="center center" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <div fxFlex="80%" fxLayout="column">
                        <p i18n="@@welcome-paragraph" name="welcome-paragraph" class="content" id="welcome-paragraph">
                            WEST puts you in charge of your learning and gives you all the tools and support you need
                            for Essential Skills success.</p>
                    </div>
                </div>
                <div fxLayoutAlign="center">
                    <button i18n="@@button-sign-in" name="button-sign-in" fxFlex="75%" fxFlex.xs="80%" mat-raised-button
                        color="primary" (click)="login()" id="btnSignIn">Sign in</button>
                </div>
            </div>
            <br />
            <br />
            <mat-card fxFlex="60%" fxFlex.xs="80%" fxLayoutAlign="center center" class="mat-elevation-z4 bg-grey">
                <mat-card-content fxFlex.xs="90%" fxLayout="column" fxFlexAlign="center center" fxLayoutGap="10px">
                    <div></div>
                    <p i18n="@@screener-paragraph" name="screener-paragraph" id="screener-paragraph">
                        Do you want to take a WEST screener to understand your current skill level?
                    </p>
                    <div fxLayoutAlign="center">
                        <button i18n="@@button-screener" name="button-screener" id="btnScreener" fxFlex="80%"
                            fxFlex.xs="100%" mat-raised-button color="primary" routerLink="/screener"
                            routerLinkActive="active">Take a screener</button>
                    </div>
                    <div></div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <br />
</section>